import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Spinner } from '../ui/Spinner';

/**
 * Client-side guard for admin routes.
 * NOTE: Every admin Edge Function also calls verifyAdmin() server-side -
 * this guard is only UX protection, not a security boundary.
 */
export function AdminAPGuard() {
  const { profile, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--bg-base)',
      }}>
        <Spinner size="lg" />
      </div>
    );
  }

  if (!profile) return <Navigate to="/login" replace />;

  if (profile.role !== 'admin') {
    const isAstrologer = profile.subscription_tier === 'astrologer_pro';
    return <Navigate to={isAstrologer ? '/profissional/portal' : '/dashboard'} replace />;
  }

  return <Outlet />;
}
